// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.deleted-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
}
.deleted-placeholder .deleted-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  opacity: 0.4;
  margin-bottom: 1rem;
}
.deleted-placeholder h3 {
  margin: 0 0 0.5rem 0;
  font-weight: 500;
  color: var(--text-primary, inherit);
}
.deleted-placeholder p {
  margin: 0;
  font-size: 0.875rem;
  opacity: 0.8;
}

.agent-settings-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.agent-settings-form > .error-message {
  flex-shrink: 0;
}
.agent-settings-form > .form-field-row {
  flex-shrink: 0;
}

.form-scroll-content {
  flex: 1;
  overflow-y: auto;
  margin-top: 15px;
  overflow-x: hidden;
  scrollbar-width: auto;
  scrollbar-color: rgba(128, 128, 128, 0.5) rgba(128, 128, 128, 0.1);
}
.form-scroll-content::-webkit-scrollbar {
  width: 10px;
}
.form-scroll-content::-webkit-scrollbar-track {
  background: rgba(128, 128, 128, 0.1);
  border-radius: 5px;
}
.form-scroll-content::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.4);
  border-radius: 5px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.form-scroll-content::-webkit-scrollbar-thumb:hover {
  background: rgba(128, 128, 128, 0.6);
  background-clip: padding-box;
}

.form-field {
  width: 200px;
  min-width: 150px;
}

.form-field-small {
  width: 140px;
  min-width: 100px;
}

.button-row {
  padding: 0 var(--content-margin, 20px);
  margin-top: 10px;
  margin-bottom: 10px;
}

.error-message {
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.3);
  color: #dc3545;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  margin: 0 var(--content-margin, 20px);
}

.success-message {
  background: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.3);
  color: #28a745;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  margin: 0 var(--content-margin, 20px);
}

.mcp-servers-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mcp-label {
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 0.8;
  margin-bottom: 0.25rem;
}

.mcp-servers-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
  padding: 0.75rem;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  border-radius: 4px;
  background: var(--input-bg, rgba(0, 0, 0, 0.04));
}

.mcp-server-item .checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
}
.mcp-server-item .checkbox-label input[type=checkbox] {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}
.mcp-server-item .checkbox-label .server-name {
  font-weight: 500;
}
.mcp-server-item .checkbox-label .server-tools {
  color: var(--text-color-muted, rgba(0, 0, 0, 0.6));
  font-size: 0.75rem;
}
.mcp-server-item .checkbox-label .server-status {
  margin-left: auto;
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background: rgba(108, 117, 125, 0.1);
  color: var(--text-color-muted, #666);
}
.mcp-server-item .checkbox-label .server-status.running {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.primary-agent-row {
  margin-top: 2px;
  margin-bottom: 8px;
  padding: 0 4px;
}

.primary-agent-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 13px;
  cursor: pointer;
}
.primary-agent-label .primary-agent-hint {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

:host ::ng-deep .form-field-row {
  flex-wrap: wrap;
}

.form-field-with-action {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.form-field-with-action .field-action-button {
  margin-top: 8px;
  opacity: 0.7;
}
.form-field-with-action .field-action-button:hover {
  opacity: 1;
}

.system-prompt-wrapper {
  position: relative;
  padding-top: 28px;
}
.system-prompt-wrapper mat-form-field {
  width: 100%;
}
.system-prompt-wrapper .system-prompt-edit-btn {
  position: absolute;
  top: -10px;
  right: 0;
  z-index: 1;
  opacity: 0.7;
}
.system-prompt-wrapper .system-prompt-edit-btn::before {
  display: none !important;
}
.system-prompt-wrapper .system-prompt-edit-btn ::ng-deep .mat-mdc-button-persistent-ripple,
.system-prompt-wrapper .system-prompt-edit-btn ::ng-deep .mat-mdc-focus-indicator {
  display: none;
}
.system-prompt-wrapper .system-prompt-edit-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.system-prompt-wrapper .system-prompt-edit-btn:hover {
  opacity: 1;
}

.mcp-overrides-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
}

.mcp-overrides-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mcp-overrides-header .add-server-btn {
  opacity: 0.7;
}
.mcp-overrides-header .add-server-btn:hover {
  opacity: 1;
}

.mcp-hint {
  font-size: 0.75rem;
  color: var(--text-color-muted, rgba(0, 0, 0, 0.5));
  margin: 0;
  padding: 0.5rem 0;
}

.mcp-override-cards {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mcp-override-card {
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  border-radius: 4px;
  background: var(--input-bg, rgba(0, 0, 0, 0.02));
  overflow: hidden;
}

.mcp-card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  background: rgba(128, 128, 128, 0.1);
  transition: background 0.15s ease;
}
.mcp-card-header:hover {
  background: rgba(128, 128, 128, 0.15);
}
.mcp-card-header .expand-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
  opacity: 0.6;
}
.mcp-card-header .expand-icon.expanded {
  transform: rotate(90deg);
}
.mcp-card-header .server-name {
  font-weight: 500;
  font-size: 0.875rem;
}
.mcp-card-header .env-count {
  font-size: 0.75rem;
  opacity: 0.6;
  margin-left: auto;
}
.mcp-card-header .remove-server-btn {
  opacity: 0.5;
}
.mcp-card-header .remove-server-btn:hover {
  opacity: 1;
  color: #dc3545;
}

.mcp-card-body {
  padding: 0.75rem;
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.mcp-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.mcp-field label {
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.7;
}
.mcp-field input {
  font-size: 0.875rem;
  padding: 0.375rem 0.5rem;
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 4px;
  background: rgba(128, 128, 128, 0.1);
  color: inherit;
  font-family: monospace;
}
.mcp-field input:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
}
.mcp-field input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mcp-env-section .env-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}
.mcp-env-section .env-header label {
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.7;
}
.mcp-env-section .env-header .add-env-btn {
  width: 24px;
  height: 24px;
  line-height: 24px;
  opacity: 0.7;
}
.mcp-env-section .env-header .add-env-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.mcp-env-section .env-header .add-env-btn:hover {
  opacity: 1;
}

.env-vars-list {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.env-var-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.env-var-row .env-key {
  font-size: 0.7rem;
  font-family: monospace;
  font-weight: 500;
  color: var(--text-color, inherit);
  min-width: 140px;
  max-width: 160px;
  word-break: break-all;
  line-height: 1.3;
}
.env-var-row .env-value {
  flex: 1;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 4px;
  background: rgba(128, 128, 128, 0.1);
  color: inherit;
  font-family: monospace;
}
.env-var-row .env-value:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
}
.env-var-row .env-value:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.env-var-row .env-value[type=password] {
  letter-spacing: 0.1em;
}
.env-var-row .visibility-btn {
  width: 24px;
  height: 24px;
  line-height: 24px;
  opacity: 0.5;
}
.env-var-row .visibility-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.env-var-row .visibility-btn:hover {
  opacity: 1;
}
.env-var-row .remove-env-btn {
  width: 24px;
  height: 24px;
  line-height: 24px;
  opacity: 0.5;
}
.env-var-row .remove-env-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.env-var-row .remove-env-btn:hover {
  opacity: 1;
  color: #dc3545;
}

.no-env-hint {
  font-size: 0.75rem;
  color: var(--text-color-muted, rgba(0, 0, 0, 0.4));
  margin: 0;
  padding: 0.25rem 0;
  font-style: italic;
}

.settings-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
.settings-tabs ::ng-deep .mat-mdc-tab-body-wrapper {
  flex: 1;
  overflow: hidden;
}
.settings-tabs ::ng-deep .mat-mdc-tab-body {
  height: 100%;
}
.settings-tabs ::ng-deep .mat-mdc-tab-body-content {
  height: 100%;
  overflow: hidden;
}
.settings-tabs ::ng-deep .mat-mdc-tab-header {
  flex-shrink: 0;
}
.settings-tabs ::ng-deep .mdc-tab {
  background-color: transparent !important;
}
.settings-tabs ::ng-deep .mdc-tab--active {
  background-color: transparent !important;
}
.settings-tabs ::ng-deep .mat-mdc-tab-label-container,
.settings-tabs ::ng-deep .mat-mdc-tab-group {
  background-color: transparent !important;
}

.button-row {
  flex-shrink: 0;
  padding: 8px 16px 12px;
  border-top: 1px solid var(--mat-divider-color, rgba(0, 0, 0, 0.12));
}

.responsibilities-section {
  padding: 15px var(--content-margin, 20px) 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stimulus-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stimulus-item {
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  border-radius: 6px;
  background: var(--input-bg, rgba(0, 0, 0, 0.02));
  padding: 10px 12px;
  transition: opacity 0.15s;
}
.stimulus-item.disabled {
  opacity: 0.5;
}

.stimulus-item-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stimulus-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  opacity: 0.6;
  flex-shrink: 0;
}

.stimulus-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.stimulus-name {
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stimulus-instruction {
  font-size: 0.75rem;
  opacity: 0.65;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: italic;
}

.stimulus-trigger {
  font-size: 0.75rem;
  font-family: monospace;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stimulus-last-ran {
  font-size: 0.7rem;
  opacity: 0.5;
}

.stimulus-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.stimulus-toggle {
  margin-right: 4px;
}
.stimulus-toggle ::ng-deep .mdc-switch {
  transform: scale(0.85);
}

.stimulus-edit-btn,
.stimulus-remove-btn {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  opacity: 0.5;
}
.stimulus-edit-btn ::ng-deep .mat-mdc-button-touch-target,
.stimulus-remove-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 28px !important;
  height: 28px !important;
  top: 0 !important;
  left: 0 !important;
}
.stimulus-edit-btn ::ng-deep .mat-icon,
.stimulus-remove-btn ::ng-deep .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.stimulus-edit-btn:hover,
.stimulus-remove-btn:hover {
  opacity: 1;
}

.stimulus-remove-btn:hover {
  color: #dc3545;
}

.stimulus-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 16px;
  opacity: 0.6;
}
.stimulus-empty mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  opacity: 0.5;
}
.stimulus-empty p {
  margin: 0;
  font-size: 0.875rem;
}
.stimulus-empty .stimulus-empty-hint {
  margin-top: 6px;
  font-size: 0.75rem;
  opacity: 0.8;
  max-width: 320px;
}

.add-stimulus-btn {
  align-self: flex-start;
  opacity: 0.8;
}
.add-stimulus-btn:hover {
  opacity: 1;
}

.stimulus-form {
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  border-radius: 6px;
  padding: 12px;
  background: var(--input-bg, rgba(0, 0, 0, 0.02));
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stimulus-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.stimulus-form-title {
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 0.8;
}

.form-close-btn {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  opacity: 0.5;
}
.form-close-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 24px !important;
  height: 24px !important;
  top: 0 !important;
  left: 0 !important;
}
.form-close-btn ::ng-deep .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.form-close-btn:hover {
  opacity: 1;
}

.stimulus-field {
  width: 100%;
}

.cron-field-wrapper {
  width: 100%;
}

.cron-field-label {
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.7;
  display: block;
  margin-bottom: 2px;
}

.stimulus-toggle-row {
  padding: 4px 0;
}
.stimulus-toggle-row .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  cursor: pointer;
}
.stimulus-toggle-row .checkbox-label input[type=checkbox] {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.stimulus-form-actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.skills-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skills-hint {
  font-size: 0.75rem;
  color: var(--text-color-muted, #888);
  margin: 0;
  opacity: 0.8;
}

.skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  border-radius: 4px;
  background: var(--input-bg, rgba(0, 0, 0, 0.04));
}

.skill-item .checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  background: rgba(128, 128, 128, 0.1);
  transition: background 0.15s ease;
}
.skill-item .checkbox-label:hover {
  background: rgba(128, 128, 128, 0.2);
}
.skill-item .checkbox-label input[type=checkbox] {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}
.skill-item .checkbox-label .skill-name {
  font-weight: 500;
}
.skill-item.skill-personal {
  opacity: 0.6;
}
.skill-item.skill-personal .checkbox-label {
  cursor: default;
}
.skill-item.skill-personal .checkbox-label input[type=checkbox] {
  cursor: not-allowed;
}
.skill-item.skill-personal .skill-personal-badge {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgba(128, 128, 128, 0.8);
  background: rgba(128, 128, 128, 0.15);
  padding: 0.1rem 0.35rem;
  border-radius: 3px;
}

::ng-deep .pool-cred {
  opacity: 0.55;
  font-size: 0.85em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/agent-settings-widget/agent-settings-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAGA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,gDAAA;AAAF;AAEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,oBAAA;EACA,gBAAA;EACA,mCAAA;AADJ;AAIE;EACE,SAAA;EACA,mBAAA;EACA,YAAA;AAFJ;;AAMA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAHF;AAME;EACE,cAAA;AAJJ;AAQE;EACE,cAAA;AANJ;;AAWA;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kEAAA;AARF;AAUE;EACE,WAAA;AARJ;AAWE;EACE,oCAAA;EACA,kBAAA;AATJ;AAYE;EACE,oCAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;AAVJ;AAYI;EACE,oCAAA;EACA,4BAAA;AAVN;;AAgBA;EACE,YAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,gBAAA;AAbF;;AAiBA;EACE,sCAAA;EACA,gBAAA;EACA,mBAAA;AAdF;;AAkBA;EACE,kCAAA;EACA,wCAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;AAfF;;AAmBA;EACE,kCAAA;EACA,wCAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;AAhBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0DAAA;EACA,kBAAA;EACA,gDAAA;AAjBF;;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlBN;AAqBI;EACE,gBAAA;AAnBN;AAsBI;EACE,kDAAA;EACA,kBAAA;AApBN;AAuBI;EACE,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,oCAAA;EACA,oCAAA;AArBN;AAuBM;EACE,kCAAA;EACA,cAAA;AArBR;;AA4BA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAzBF;AA2BE;EACE,+BAAA;EACA,eAAA;AAzBJ;;AA8BA;EACE,eAAA;AA3BF;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AA5BF;AA8BE;EACE,eAAA;EACA,YAAA;AA5BJ;AA8BI;EACE,UAAA;AA5BN;;AAkCA;EACE,kBAAA;EACA,iBAAA;AA/BF;AAiCE;EACE,WAAA;AA/BJ;AAkCE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AAhCJ;AAmCI;EACE,wBAAA;AAjCN;AAoCI;;EAEE,aAAA;AAlCN;AAqCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnCN;AAsCI;EACE,UAAA;AApCN;;AA2CA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,8DAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAxCF;AA0CE;EACE,YAAA;AAxCJ;AAyCI;EACE,UAAA;AAvCN;;AA4CA;EACE,kBAAA;EACA,kDAAA;EACA,SAAA;EACA,iBAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,0DAAA;EACA,kBAAA;EACA,gDAAA;EACA,gBAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,oCAAA;EACA,iCAAA;AAzCF;AA2CE;EACE,qCAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,YAAA;AA1CJ;AA4CI;EACE,wBAAA;AA1CN;AA8CE;EACE,gBAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AA7CJ;AAgDE;EACE,YAAA;AA9CJ;AA+CI;EACE,UAAA;EACA,cAAA;AA7CN;;AAkDA;EACE,gBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA/CF;AAiDE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AA/CJ;AAkDE;EACE,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,sBAAA;AAhDJ;AAkDI;EACE,aAAA;EACA,2CAAA;AAhDN;AAmDI;EACE,YAAA;EACA,mBAAA;AAjDN;;AAuDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AApDJ;AAsDI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AApDN;AAuDI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AArDN;AAuDM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArDR;AAwDM;EACE,UAAA;AAtDR;;AA4DA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAzDF;AA2DE;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AAzDJ;AA4DE;EACE,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,sBAAA;AA1DJ;AA4DI;EACE,aAAA;EACA,2CAAA;AA1DN;AA6DI;EACE,YAAA;EACA,mBAAA;AA3DN;AA8DI;EACE,qBAAA;AA5DN;AAgEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AA9DJ;AAgEI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9DN;AAiEI;EACE,UAAA;AA/DN;AAmEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAjEJ;AAmEI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAjEN;AAoEI;EACE,UAAA;EACA,cAAA;AAlEN;;AAuEA;EACE,kBAAA;EACA,kDAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AApEF;;AAyEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAtEF;AAwEE;EACE,OAAA;EACA,gBAAA;AAtEJ;AAyEE;EACE,YAAA;AAvEJ;AA0EE;EACE,YAAA;EACA,gBAAA;AAxEJ;AA2EE;EACE,cAAA;AAzEJ;AA6EE;EACE,wCAAA;AA3EJ;AA8EE;EACE,wCAAA;AA5EJ;AA+EE;;EAEE,wCAAA;AA7EJ;;AAiFA;EACE,cAAA;EACA,sBAAA;EACA,mEAAA;AA9EF;;AAmFA;EACE,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhFF;;AAmFA;EACE,0DAAA;EACA,kBAAA;EACA,gDAAA;EACA,kBAAA;EACA,yBAAA;AAhFF;AAkFE;EACE,YAAA;AAhFJ;;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAjFF;;AAoFA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAjFF;;AAoFA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjFF;;AAoFA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAjFF;;AAoFA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjFF;;AAoFA;EACE,iBAAA;EACA,YAAA;AAjFF;;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAjFF;;AAoFA;EACE,iBAAA;AAjFF;AAkFE;EACE,sBAAA;AAhFJ;;AAoFA;;EAEE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AAjFF;AAoFE;;EACE,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAjFJ;AAoFE;;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjFJ;AAoFE;;EACE,UAAA;AAjFJ;;AAqFA;EACE,cAAA;AAlFF;;AAsFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAnFF;AAqFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAnFJ;AAsFE;EACE,SAAA;EACA,mBAAA;AApFJ;AAuFE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AArFJ;;AAyFA;EACE,sBAAA;EACA,YAAA;AAtFF;AAwFE;EACE,UAAA;AAtFJ;;AA2FA;EACE,0DAAA;EACA,kBAAA;EACA,aAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAxFF;;AA2FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAxFF;;AA2FA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;AAxFF;;AA2FA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AAxFF;AA0FE;EACE,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAxFJ;AA2FE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAzFJ;AA4FE;EACE,UAAA;AA1FJ;;AA8FA;EACE,WAAA;AA3FF;;AA8FA;EACE,WAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AA3FF;;AA8FA;EACE,cAAA;AA3FF;AA6FE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AA3FJ;AA6FI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA3FN;;AAgGA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA7FF;;AAkGA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA/FF;;AAkGA;EACE,kBAAA;EACA,oCAAA;EACA,SAAA;EACA,YAAA;AA/FF;;AAkGA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,0DAAA;EACA,kBAAA;EACA,gDAAA;AA/FF;;AAmGE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,iCAAA;AAhGJ;AAkGI;EACE,oCAAA;AAhGN;AAmGI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAjGN;AAoGI;EACE,gBAAA;AAlGN;AAsGE;EACE,YAAA;AApGJ;AAsGI;EACE,eAAA;AApGN;AAsGM;EACE,mBAAA;AApGR;AAwGI;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,uBAAA;EACA,kBAAA;AAtGN;;AA4GA;EACE,aAAA;EACA,iBAAA;AAzGF","sourcesContent":[".content {\n  height: calc(100% - 24px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Deleted placeholder\n.deleted-placeholder {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-secondary, rgba(0, 0, 0, 0.6));\n\n  .deleted-icon {\n    font-size: 64px;\n    width: 64px;\n    height: 64px;\n    opacity: 0.4;\n    margin-bottom: 1rem;\n  }\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-weight: 500;\n    color: var(--text-primary, inherit);\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.875rem;\n    opacity: 0.8;\n  }\n}\n\n.agent-settings-form {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  // Error message stays visible\n  > .error-message {\n    flex-shrink: 0;\n  }\n\n  // Form field rows scroll\n  > .form-field-row {\n    flex-shrink: 0;\n  }\n}\n\n// Scrollable form content wrapper\n.form-scroll-content {\n  flex: 1;\n  overflow-y: auto;\n  margin-top: 15px;\n  overflow-x: hidden;\n  scrollbar-width: auto;\n  scrollbar-color: rgba(128, 128, 128, 0.5) rgba(128, 128, 128, 0.1);\n\n  &::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(128, 128, 128, 0.1);\n    border-radius: 5px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(128, 128, 128, 0.4);\n    border-radius: 5px;\n    border: 2px solid transparent;\n    background-clip: padding-box;\n\n    &:hover {\n      background: rgba(128, 128, 128, 0.6);\n      background-clip: padding-box;\n    }\n  }\n}\n\n// Match vault-detail field sizing\n.form-field {\n  width: 200px;\n  min-width: 150px;\n}\n\n.form-field-small {\n  width: 140px;\n  min-width: 100px;\n}\n\n// Button row - matches vault-detail #button-row\n.button-row {\n  padding: 0 var(--content-margin, 20px);\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n// Error message styling\n.error-message {\n  background: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  color: #dc3545;\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  margin: 0 var(--content-margin, 20px);\n}\n\n// Success message styling\n.success-message {\n  background: rgba(40, 167, 69, 0.1);\n  border: 1px solid rgba(40, 167, 69, 0.3);\n  color: #28a745;\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  margin: 0 var(--content-margin, 20px);\n}\n\n// MCP Servers section\n.mcp-servers-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.mcp-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  opacity: 0.8;\n  margin-bottom: 0.25rem;\n}\n\n.mcp-servers-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));\n  border-radius: 4px;\n  background: var(--input-bg, rgba(0, 0, 0, 0.04));\n}\n\n.mcp-server-item {\n  .checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n\n    input[type='checkbox'] {\n      width: 1rem;\n      height: 1rem;\n      cursor: pointer;\n    }\n\n    .server-name {\n      font-weight: 500;\n    }\n\n    .server-tools {\n      color: var(--text-color-muted, rgba(0, 0, 0, 0.6));\n      font-size: 0.75rem;\n    }\n\n    .server-status {\n      margin-left: auto;\n      font-size: 0.75rem;\n      padding: 0.125rem 0.5rem;\n      border-radius: 0.25rem;\n      background: rgba(108, 117, 125, 0.1);\n      color: var(--text-color-muted, #666);\n\n      &.running {\n        background: rgba(40, 167, 69, 0.1);\n        color: #28a745;\n      }\n    }\n  }\n}\n\n// Primary agent toggle\n.primary-agent-row {\n  margin-top: 2px;\n  margin-bottom: 8px;\n  padding: 0 4px;\n}\n\n.primary-agent-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 13px;\n  cursor: pointer;\n\n  .primary-agent-hint {\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 12px;\n  }\n}\n\n// Make form-field-row wrap on narrow widgets\n:host ::ng-deep .form-field-row {\n  flex-wrap: wrap;\n}\n\n// Field with action button (e.g., backend selector with manage button)\n.form-field-with-action {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n\n  .field-action-button {\n    margin-top: 8px;\n    opacity: 0.7;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n// System prompt wrapper with edit button positioned above top-right\n.system-prompt-wrapper {\n  position: relative;\n  padding-top: 28px; // Make room for the button above\n\n  mat-form-field {\n    width: 100%;\n  }\n\n  .system-prompt-edit-btn {\n    position: absolute;\n    top: -10px;\n    right: 0;\n    z-index: 1;\n    opacity: 0.7;\n\n    // Remove hover shadow/background\n    &::before {\n      display: none !important;\n    }\n\n    ::ng-deep .mat-mdc-button-persistent-ripple,\n    ::ng-deep .mat-mdc-focus-indicator {\n      display: none;\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n// ============ MCP Server Overrides Section ============\n\n.mcp-overrides-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n}\n\n.mcp-overrides-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .add-server-btn {\n    opacity: 0.7;\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.mcp-hint {\n  font-size: 0.75rem;\n  color: var(--text-color-muted, rgba(0, 0, 0, 0.5));\n  margin: 0;\n  padding: 0.5rem 0;\n}\n\n.mcp-override-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.mcp-override-card {\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));\n  border-radius: 4px;\n  background: var(--input-bg, rgba(0, 0, 0, 0.02));\n  overflow: hidden;\n}\n\n.mcp-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  background: rgba(128, 128, 128, 0.1);\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: rgba(128, 128, 128, 0.15);\n  }\n\n  .expand-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    transition: transform 0.2s ease;\n    opacity: 0.6;\n\n    &.expanded {\n      transform: rotate(90deg);\n    }\n  }\n\n  .server-name {\n    font-weight: 500;\n    font-size: 0.875rem;\n  }\n\n  .env-count {\n    font-size: 0.75rem;\n    opacity: 0.6;\n    margin-left: auto;\n  }\n\n  .remove-server-btn {\n    opacity: 0.5;\n    &:hover {\n      opacity: 1;\n      color: #dc3545;\n    }\n  }\n}\n\n.mcp-card-body {\n  padding: 0.75rem;\n  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.mcp-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n\n  label {\n    font-size: 0.75rem;\n    font-weight: 500;\n    opacity: 0.7;\n  }\n\n  input {\n    font-size: 0.875rem;\n    padding: 0.375rem 0.5rem;\n    border: 1px solid rgba(128, 128, 128, 0.3);\n    border-radius: 4px;\n    background: rgba(128, 128, 128, 0.1);\n    color: inherit;\n    font-family: monospace;\n\n    &:focus {\n      outline: none;\n      border-color: var(--primary-color, #3b82f6);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.mcp-env-section {\n  .env-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 0.25rem;\n\n    label {\n      font-size: 0.75rem;\n      font-weight: 500;\n      opacity: 0.7;\n    }\n\n    .add-env-btn {\n      width: 24px;\n      height: 24px;\n      line-height: 24px;\n      opacity: 0.7;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.env-vars-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.env-var-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n\n  .env-key {\n    font-size: 0.7rem;\n    font-family: monospace;\n    font-weight: 500;\n    color: var(--text-color, inherit);\n    min-width: 140px;\n    max-width: 160px;\n    word-break: break-all;\n    line-height: 1.3;\n  }\n\n  .env-value {\n    flex: 1;\n    font-size: 0.875rem;\n    padding: 0.25rem 0.5rem;\n    border: 1px solid rgba(128, 128, 128, 0.3);\n    border-radius: 4px;\n    background: rgba(128, 128, 128, 0.1);\n    color: inherit;\n    font-family: monospace;\n\n    &:focus {\n      outline: none;\n      border-color: var(--primary-color, #3b82f6);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &[type='password'] {\n      letter-spacing: 0.1em;\n    }\n  }\n\n  .visibility-btn {\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    opacity: 0.5;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  .remove-env-btn {\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    opacity: 0.5;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      opacity: 1;\n      color: #dc3545;\n    }\n  }\n}\n\n.no-env-hint {\n  font-size: 0.75rem;\n  color: var(--text-color-muted, rgba(0, 0, 0, 0.4));\n  margin: 0;\n  padding: 0.25rem 0;\n  font-style: italic;\n}\n\n// ============ Tabs ============\n\n.settings-tabs {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n\n  ::ng-deep .mat-mdc-tab-body-wrapper {\n    flex: 1;\n    overflow: hidden;\n  }\n\n  ::ng-deep .mat-mdc-tab-body {\n    height: 100%;\n  }\n\n  ::ng-deep .mat-mdc-tab-body-content {\n    height: 100%;\n    overflow: hidden;\n  }\n\n  ::ng-deep .mat-mdc-tab-header {\n    flex-shrink: 0;\n  }\n\n  // Override global theme that sets inactive tabs to --preset-code color\n  ::ng-deep .mdc-tab {\n    background-color: transparent !important;\n  }\n\n  ::ng-deep .mdc-tab--active {\n    background-color: transparent !important;\n  }\n\n  ::ng-deep .mat-mdc-tab-label-container,\n  ::ng-deep .mat-mdc-tab-group {\n    background-color: transparent !important;\n  }\n}\n\n.button-row {\n  flex-shrink: 0;\n  padding: 8px 16px 12px;\n  border-top: 1px solid var(--mat-divider-color, rgba(0,0,0,0.12));\n}\n\n// ============ Responsibilities Section ============\n\n.responsibilities-section {\n  padding: 15px var(--content-margin, 20px) 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.stimulus-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.stimulus-item {\n  border: 1px solid var(--border-color, rgba(0,0,0,0.12));\n  border-radius: 6px;\n  background: var(--input-bg, rgba(0,0,0,0.02));\n  padding: 10px 12px;\n  transition: opacity 0.15s;\n\n  &.disabled {\n    opacity: 0.5;\n  }\n}\n\n.stimulus-item-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.stimulus-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n.stimulus-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.stimulus-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.stimulus-instruction {\n  font-size: 0.75rem;\n  opacity: 0.65;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-style: italic;\n}\n\n.stimulus-trigger {\n  font-size: 0.75rem;\n  font-family: monospace;\n  opacity: 0.7;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.stimulus-last-ran {\n  font-size: 0.7rem;\n  opacity: 0.5;\n}\n\n.stimulus-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.stimulus-toggle {\n  margin-right: 4px;\n  ::ng-deep .mdc-switch {\n    transform: scale(0.85);\n  }\n}\n\n.stimulus-edit-btn,\n.stimulus-remove-btn {\n  width: 28px !important;\n  height: 28px !important;\n  padding: 0 !important;\n  opacity: 0.5;\n\n  // Collapse MDC touch target to match visual size so icon centers correctly\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: 28px !important;\n    height: 28px !important;\n    top: 0 !important;\n    left: 0 !important;\n  }\n\n  ::ng-deep .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.stimulus-remove-btn:hover {\n  color: #dc3545;\n}\n\n// Empty state\n.stimulus-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 24px 16px;\n  opacity: 0.6;\n\n  mat-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n    margin-bottom: 8px;\n    opacity: 0.5;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.875rem;\n  }\n\n  .stimulus-empty-hint {\n    margin-top: 6px;\n    font-size: 0.75rem;\n    opacity: 0.8;\n    max-width: 320px;\n  }\n}\n\n.add-stimulus-btn {\n  align-self: flex-start;\n  opacity: 0.8;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n// Stimulus add/edit form\n.stimulus-form {\n  border: 1px solid var(--border-color, rgba(0,0,0,0.12));\n  border-radius: 6px;\n  padding: 12px;\n  background: var(--input-bg, rgba(0,0,0,0.02));\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stimulus-form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.stimulus-form-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  opacity: 0.8;\n}\n\n.form-close-btn {\n  width: 24px !important;\n  height: 24px !important;\n  padding: 0 !important;\n  opacity: 0.5;\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: 24px !important;\n    height: 24px !important;\n    top: 0 !important;\n    left: 0 !important;\n  }\n\n  ::ng-deep .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.stimulus-field {\n  width: 100%;\n}\n\n.cron-field-wrapper {\n  width: 100%;\n}\n\n.cron-field-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  opacity: 0.7;\n  display: block;\n  margin-bottom: 2px;\n}\n\n.stimulus-toggle-row {\n  padding: 4px 0;\n\n  .checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.875rem;\n    cursor: pointer;\n\n    input[type='checkbox'] {\n      width: 1rem;\n      height: 1rem;\n      cursor: pointer;\n    }\n  }\n}\n\n.stimulus-form-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n// ============ Skills Section ============\n\n.skills-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skills-hint {\n  font-size: 0.75rem;\n  color: var(--text-color-muted, #888);\n  margin: 0;\n  opacity: 0.8;\n}\n\n.skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));\n  border-radius: 4px;\n  background: var(--input-bg, rgba(0, 0, 0, 0.04));\n}\n\n.skill-item {\n  .checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    background: rgba(128, 128, 128, 0.1);\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: rgba(128, 128, 128, 0.2);\n    }\n\n    input[type='checkbox'] {\n      width: 1rem;\n      height: 1rem;\n      cursor: pointer;\n    }\n\n    .skill-name {\n      font-weight: 500;\n    }\n  }\n\n  &.skill-personal {\n    opacity: 0.6;\n\n    .checkbox-label {\n      cursor: default;\n\n      input[type='checkbox'] {\n        cursor: not-allowed;\n      }\n    }\n\n    .skill-personal-badge {\n      font-size: 0.7rem;\n      font-weight: 600;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n      color: rgba(128, 128, 128, 0.8);\n      background: rgba(128, 128, 128, 0.15);\n      padding: 0.1rem 0.35rem;\n      border-radius: 3px;\n    }\n  }\n}\n\n// (model, credential) tuple rows — credential as a subtle property\n::ng-deep .pool-cred {\n  opacity: 0.55;\n  font-size: 0.85em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
